"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nocera-terinese": {
    "31b30aa6": [{
      "hkey": "02a5d322",
      "slug": "nocera-terinese",
      "name": "Nocera Terinese",
      "primary": true,
      "skipSearch": false
    }],
    "acquafredda": [{
      "hkey": "02a5d322",
      "slug": "nocera-terinese",
      "name": "Nocera Terinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "22915a0c": [{
      "hkey": "02a5d322",
      "slug": "nocera-terinese",
      "name": "Nocera Terinese",
      "primary": true,
      "skipSearch": false
    }],
    "ferole": [{
      "hkey": "02a5d322",
      "slug": "nocera-terinese",
      "name": "Nocera Terinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "62c82034": [{
      "hkey": "02a5d322",
      "slug": "nocera-terinese",
      "name": "Nocera Terinese",
      "primary": true,
      "skipSearch": false
    }],
    "maletta": [{
      "hkey": "02a5d322",
      "slug": "nocera-terinese",
      "name": "Nocera Terinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9511e502": [{
      "hkey": "d1902d43",
      "slug": "nocera-scalo",
      "name": "Nocera Scalo",
      "primary": true,
      "skipSearch": false
    }],
    "nocera-terinese-marina": [{
      "hkey": "d1902d43",
      "slug": "nocera-scalo",
      "name": "Nocera Scalo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "14b627e8": [{
      "hkey": "02a5d322",
      "slug": "nocera-terinese",
      "name": "Nocera Terinese",
      "primary": true,
      "skipSearch": false
    }],
    "varano": [{
      "hkey": "02a5d322",
      "slug": "nocera-terinese",
      "name": "Nocera Terinese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;